import { convertToLocalDate } from "../../utils/FormatDate";
import { truncateDecimals } from "../../utils/TruncateDecimals";

export const combinedRecords = (data) => {
    // Initialize an empty object to hold the consolidated data
    const consolidatedData = {};

    data.forEach(entry => {
        const { recordedDate, ...parameters } = entry;

        // Convert recordedDate to local system time
        const localRecordedDate =convertToLocalDate(recordedDate);

        // Process each parameter to restrict to 3 decimal places without rounding off
        const processedParameters = {};
        Object.keys(parameters).forEach(key => {
            processedParameters[key] = truncateDecimals(parameters[key])
        });

        // If the date already exists in the consolidated data, merge the new parameters
        if (consolidatedData[localRecordedDate]) {
            consolidatedData[localRecordedDate] = { ...consolidatedData[localRecordedDate], ...processedParameters };
        } else {
            // If the date does not exist, create a new entry for that date
            consolidatedData[localRecordedDate] = { recordedDate: localRecordedDate, ...processedParameters };
        }
    });

    // Get all unique parameter names
    const allParameters = new Set(data.flatMap(entry => Object.keys(entry)).filter(key => key !== 'recordedDate'));

    // Convert the consolidated data back into an array and fill in missing parameters with empty strings
    const result = Object.values(consolidatedData).map(entry => {
        const completeEntry = { ...entry };

        allParameters.forEach(param => {
            if (!(param in completeEntry)) {
                completeEntry[param] = '';
            }
        });

        return completeEntry;
    });

    return result;
};
